{
  "Clear search": "Wyczyść zawartość wyszukiwania"
}
